<svg
  #svg
  class="room-layer"
  [class.room-layer--editable]="editable"
  [class.room-layer--draw]="editable && tool !== 'select'"
  [attr.viewBox]="viewBox"
  preserveAspectRatio="none"
  xmlns="http://www.w3.org/2000/svg"
  (pointerdown)="onSvgPointerDown($event)"
  (pointermove)="onSvgPointerMove($event)"
  (pointerup)="onSvgPointerUp($event)"
  (pointercancel)="onSvgPointerUp($event)"
  (pointerleave)="onSvgPointerLeave()"
>
  <!-- Rooms -->
  <g
    *ngFor="let item of renderedRooms; trackBy: trackByRoom"
    class="room"
    [class.room--selected]="item.room.id === selectedRoomId"
    [class.room--highlight]="item.room.id === highlightRoomId"
    [class.room--muted]="editable && !!selectedRoomId && item.room.id !== selectedRoomId"
    [style.--room-color]="item.color"
  >
    <polygon
      class="room-shape"
      [attr.points]="item.points"
      vector-effect="non-scaling-stroke"
      (pointerdown)="onRoomPointerDown($event, item.room)"
    >
      <title>{{ item.room.name }}</title>
    </polygon>
    <ng-container *ngIf="labelFontFor(item) as font">
      <text
        class="room-label"
        [attr.x]="item.label.x"
        [attr.y]="item.label.y"
        [attr.font-size]="font"
        text-anchor="middle"
        dominant-baseline="middle"
      >{{ item.room.name }}</text>
    </ng-container>
  </g>

  <!-- Reshape handles for the selected room -->
  <ng-container *ngIf="editable && tool === 'select' && editPoints">
    <circle
      *ngFor="let m of midpoints; let i = index; trackBy: trackByIndex"
      class="handle handle--midpoint"
      [attr.cx]="m.x"
      [attr.cy]="m.y"
      [attr.r]="midpointRadius"
      vector-effect="non-scaling-stroke"
      (pointerdown)="onMidpointPointerDown($event, i)"
    >
      <title>Drag to add a corner</title>
    </circle>
    <circle
      *ngFor="let p of editPoints; let i = index; trackBy: trackByIndex"
      class="handle handle--vertex"
      [attr.cx]="p.x"
      [attr.cy]="p.y"
      [attr.r]="vertexRadius"
      vector-effect="non-scaling-stroke"
      (pointerdown)="onVertexPointerDown($event, i)"
      (dblclick)="onVertexDoubleClick($event, i)"
    >
      <title>Drag to move · double-click to remove</title>
    </circle>
  </ng-container>

  <!-- Drawing previews -->
  <polygon
    *ngIf="rectStart && rectEnd"
    class="draft draft--closed"
    [attr.points]="rectPolygon"
    vector-effect="non-scaling-stroke"
  />
  <ng-container *ngIf="draft.length">
    <polyline class="draft" [attr.points]="draftPolyline" vector-effect="non-scaling-stroke" />
    <circle
      *ngFor="let p of draft; let i = index; trackBy: trackByIndex"
      class="draft-vertex"
      [class.draft-vertex--close]="i === 0 && canClosePolygon"
      [attr.cx]="p.x"
      [attr.cy]="p.y"
      [attr.r]="i === 0 ? vertexRadius * 1.3 : vertexRadius * 0.8"
      vector-effect="non-scaling-stroke"
    />
  </ng-container>

  <circle
    *ngIf="editable && snapPoint"
    class="snap-indicator"
    [attr.cx]="snapPoint.x"
    [attr.cy]="snapPoint.y"
    [attr.r]="vertexRadius * 1.6"
    vector-effect="non-scaling-stroke"
  />
</svg>
